module.exports = __webpack_public_path__ + "img/Weapon_215.b2cf3e09.png";